export default __webpack_public_path__ + "static/cemetery-9383424e1861388c6ad00e3693ad9e23.svg";